/* Papeterie Montparnasse - header : loupe qui deroule la recherche-plume + libelles
   des actions (Rechercher / Compte / Favoris / Panier) - DEV, reversible.
   Numeros 01-05 rendus dans le mega (snippet). Ne touche pas pm-header.js. */
(function () {
  // Beige/dore signature (identite PM : noms de marque, cartes, page produit).
  var GOLD = '#B4A06A';

  function goldenize(el) {
    // Colore l'icone (SVG) en beige/dore sans toucher au libelle (encre).
    if (!el) return;
    var svg = el.querySelector('svg') || (el.tagName === 'svg' ? el : null);
    if (!svg) return;
    svg.style.setProperty('color', GOLD, 'important');
    var paths = svg.querySelectorAll('*');
    for (var p = 0; p < paths.length; p++) {
      var st = paths[p].getAttribute && paths[p].getAttribute('stroke');
      var fl = paths[p].getAttribute && paths[p].getAttribute('fill');
      if (st && st !== 'none') paths[p].style.setProperty('stroke', GOLD, 'important');
      if (fl && fl !== 'none') paths[p].style.setProperty('fill', GOLD, 'important');
    }
  }

  function label(txt) {
    var s = document.createElement('span');
    s.className = 'pm-act-label';
    s.textContent = txt;
    return s;
  }

  function initToggle(wrap) {
    if (wrap.querySelector('.pm-search-toggle')) return;
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'pm-search-toggle';
    btn.setAttribute('aria-label', 'Rechercher');
    btn.setAttribute('aria-expanded', 'false');
    btn.innerHTML =
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true">' +
      '<circle cx="11" cy="11" r="7"></circle><line x1="16.5" y1="16.5" x2="21" y2="21"></line></svg>' +
      '<span class="pm-act-label">Rechercher</span>';
    wrap.insertBefore(btn, wrap.firstChild);
    goldenize(btn);

    function focusInput() {
      var inp = wrap.querySelector('.pm-header-search input[type="search"]');
      if (inp) { try { inp.focus({ preventScroll: true }); } catch (e) { inp.focus(); } }
    }
    function open() { wrap.classList.add('pm-search-open'); btn.setAttribute('aria-expanded', 'true'); setTimeout(focusInput, 40); }
    function close() { wrap.classList.remove('pm-search-open'); btn.setAttribute('aria-expanded', 'false'); }
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      if (wrap.classList.contains('pm-search-open')) { close(); } else { open(); }
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
    document.addEventListener('click', function (e) {
      if (!wrap.classList.contains('pm-search-open')) return;
      var field = wrap.querySelector('.pm-header-search');
      if (btn.contains(e.target)) return;
      if (field && !field.contains(e.target)) close();
    });
  }

  // Aligne les 3 actions (Compte / Favoris / Panier) : icone + libelle sur une meme
  // ligne, centres. En styles inline !important pour battre les utilitaires Impact et
  // l'app wishlist. Scope desktop ; mobile inchange (les libelles y sont masques).
  function alignActions(sec) {
    if (!window.matchMedia('(min-width: 1150px)').matches) return;

    // 1) Compteurs (panier/favoris) hors-flux : le compteur panier est en
    // opacity-0 mais reste dans le flux et decale l'ancre -> on le sort du flux.
    var counts = sec.querySelectorAll('.header__cart-count');
    for (var c = 0; c < counts.length; c++) counts[c].style.setProperty('position', 'absolute', 'important');

    // References
    var acc = sec.querySelector('shopify-account .tap-area');
    var accEl = sec.querySelector('shopify-account');
    var accLi = accEl ? accEl.closest('li') : null;
    var wlBtn = sec.querySelector('ooo-wl-access-button');
    var wlLi = sec.querySelector('ooo-wl-access-button > li');
    var wlA = sec.querySelector('ooo-wl-access-button a');
    var cartA = sec.querySelector('a[aria-controls="cart-drawer"]') || sec.querySelector('a[href*="/cart"]');
    var cartLi = cartA ? cartA.closest('li') : null;
    if (cartA) cartA.classList.remove('block');

    // 2) Chaque maillon "conteneur" de la chaine flex : centre vertical.
    var links = [accLi, wlBtn, wlLi, cartLi];
    for (var k = 0; k < links.length; k++) {
      if (!links[k]) continue;
      links[k].style.setProperty('display', 'inline-flex', 'important');
      links[k].style.setProperty('align-items', 'center', 'important');
      links[k].style.setProperty('align-self', 'center', 'important');
    }

    // 3) Les 3 ancres d'action : meme boite (hauteur 20px, icone 20px, libelle),
    // centrees -> centres visuels strictement alignes.
    var anchors = [acc, wlA, cartA];
    for (var j = 0; j < anchors.length; j++) {
      var el = anchors[j];
      if (!el) continue;
      el.style.setProperty('display', 'inline-flex', 'important');
      el.style.setProperty('flex-direction', 'row', 'important');
      el.style.setProperty('align-items', 'center', 'important');
      el.style.setProperty('gap', '7px', 'important');
      el.style.setProperty('height', '20px', 'important');
      var svg = el.querySelector('svg');
      if (svg) {
        svg.style.setProperty('width', '20px', 'important');
        svg.style.setProperty('height', '20px', 'important');
        svg.style.setProperty('display', 'block', 'important');
        svg.style.setProperty('flex', 'none', 'important');
      }
      var lb = el.querySelector('.pm-act-label');
      if (lb) lb.style.setProperty('line-height', '1', 'important');
      goldenize(el);
    }
  }

  function initLabels(wrap) {
    var sec = wrap.querySelector('.header__secondary-nav');
    if (!sec) return;
    // Retire la loupe native de droite (doublon de notre loupe de gauche).
    var nativeSearch = sec.querySelector('a[aria-controls="search-drawer"]');
    if (nativeSearch) { var nsli = nativeSearch.closest('li') || nativeSearch; nsli.style.setProperty('display', 'none', 'important'); }
    // Session de test : masquer le menu secondaire (Liste scolaire, Contacts).
    var secMenu = sec.querySelector('nav.header__link-list');
    if (secMenu) secMenu.style.setProperty('display', 'none', 'important');
    // Compte
    var acc = sec.querySelector('shopify-account .tap-area') || sec.querySelector('shopify-account');
    if (acc && !acc.querySelector('.pm-act-label')) acc.appendChild(label('Compte'));
    // Favoris (liste de souhaits)
    var wl = sec.querySelector('ooo-wl-access-button a') || sec.querySelector('a[href*="souhaits"]');
    if (wl && !wl.querySelector('.pm-act-label')) wl.appendChild(label('Favoris'));
    // Panier
    var cart = sec.querySelector('a[aria-controls="cart-drawer"]') || sec.querySelector('a[href$="/cart"]') || sec.querySelector('a[href*="/cart"]');
    if (cart && !cart.querySelector('.pm-act-label')) cart.appendChild(label('Panier'));
    // Alignement (immediat + rattrapages pour le bouton wishlist rendu tardivement).
    alignActions(sec);
    setTimeout(function () { alignActions(sec); }, 350);
    setTimeout(function () { alignActions(sec); }, 1200);
  }

  var resizeBound = false;
  function init() {
    var wrap = document.querySelector('.header__wrapper');
    if (!wrap) return;
    initToggle(wrap);
    initLabels(wrap);
    if (!resizeBound) {
      resizeBound = true;
      window.addEventListener('resize', function () {
        var sec = document.querySelector('.header__wrapper .header__secondary-nav');
        if (sec) alignActions(sec);
      });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
